import { render, staticRenderFns } from "./Tab-V.vue?vue&type=template&id=a8d077c4&scoped=true"
import script from "./Tab-V.vue?vue&type=script&lang=js"
export * from "./Tab-V.vue?vue&type=script&lang=js"
import style0 from "./Tab-V.vue?vue&type=style&index=0&id=a8d077c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d077c4",
  null
  
)

export default component.exports